import DataTableBodyCell from "examples/Tables/DataTable/DataTableBodyCell";
import PropTypes from "prop-types";
import {

    Chip,
    Icon,
    IconButton,
    Switch,
    TableRow,

} from "@mui/material";


import EditButton from "components/custom/EditButton";

import useModal from "hooks/useModal";
import { memo } from "react";
import EditInputComponent from "pages/layout/EditInputComponent";
import DeleteButton from "components/custom/DeleteButton";


const RepairingStatusRow = function ({ data, currentParams, columns, onDelete, onUpdateButtonClick, onBooleanChanges }) {

    const { openModal } = useModal();

    const updateModal = (schema, val) => {





        openModal(
            <EditInputComponent value={val} schema={schema} data={data} onUpdate={onBooleanChanges} />
        );
    }

    const updateAllowed = (index) => {

        const schema = columns[index]
const fieldName = schema.key
        const val = null
        const roles = data[fieldName] && Array.isArray(data[fieldName]) && data[fieldName].map((fieldValues) =>
            fieldValues.rolecode

        )


        openModal(
            <EditInputComponent value={val} schema={schema} data={data} onUpdate={async (field, value, id) => {

                if (value && Array.isArray(value)) {
                    value.forEach(item => {
                        if (roles.indexOf(item) === -1) {
                            roles.push(item);

                        }
                    })

                }

                await onBooleanChanges(field, roles, id)
            }} />
        );
    }

    const onRemovePermission = async (code,fieldName) => {

        const roles = data[fieldName] && Array.isArray(data[fieldName]) && data[fieldName].map((fieldValues) =>
            fieldValues.rolecode

        )

        const index = roles.indexOf(parseInt(code, 10));
        if (index > -1) {
            roles.splice(index, 1);
        }
        /* eslint no-underscore-dangle: 0 */
        await onBooleanChanges(fieldName, roles, data._id)

    }

    const onChangeOfNotifyCustomer = async (e) => {

        
      
        await onBooleanChanges('notifyCustomer',e.target.checked , data._id)

    }

    return (
        <TableRow>
            <DataTableBodyCell  >
                {data.name} <EditButton
                    onUpdateButtonClick={() => {
                        /* eslint no-underscore-dangle: 0 */
                        updateModal(columns[0], data.name)

                    }}
                />
            </DataTableBodyCell>

           
            <DataTableBodyCell  >
                {data.description} <EditButton
                    onUpdateButtonClick={() => {
                        /* eslint no-underscore-dangle: 0 */
                        updateModal(columns[1], data.description)

                    }}
                />
            </DataTableBodyCell>

            <DataTableBodyCell  >
                {data.priority} <EditButton
                    onUpdateButtonClick={() => {
                        /* eslint no-underscore-dangle: 0 */
                        updateModal(columns[2], data.priority)

                    }}
                />
            </DataTableBodyCell>

            <DataTableBodyCell  >
                {data.allowed && Array.isArray(data.allowed) && data.allowed.map((allowed) =>
                    <Chip label={allowed.title} onDelete={() => { onRemovePermission(allowed.rolecode,'allowed') }} />

                )}


                <IconButton onClick={()=>updateAllowed(3)} aria-label='delete' color='info' size='small'>
                    <Icon fontSize='inherit'>add</Icon>
                </IconButton>


            </DataTableBodyCell>



            <DataTableBodyCell  >
                {data.notifyTo && Array.isArray(data.notifyTo) && data.notifyTo.map((notifyTo) =>
                    <Chip label={notifyTo.title} onDelete={() => { onRemovePermission(notifyTo.rolecode,'notifyTo') }} />

                )}


                <IconButton onClick={()=>updateAllowed(4)} aria-label='delete' color='info' size='small'>
                    <Icon fontSize='inherit'>add</Icon>
                </IconButton>


            </DataTableBodyCell>



            <DataTableBodyCell  >
                {data.inCompleted && Array.isArray(data.inCompleted) && data.inCompleted.map((inCompleted) =>
                    <Chip label={inCompleted.title} onDelete={() => { onRemovePermission(inCompleted.rolecode,'inCompleted') }} />

                )}


                <IconButton onClick={()=>updateAllowed(5)} aria-label='delete' color='info' size='small'>
                    <Icon fontSize='inherit'>add</Icon>
                </IconButton>


            </DataTableBodyCell>



            <DataTableBodyCell  >
                {data.inPending && Array.isArray(data.inPending) && data.inPending.map((inPending) =>
                    <Chip label={inPending.title} onDelete={() => { onRemovePermission(inPending.rolecode,'inPending') }} />

                )}


                <IconButton onClick={()=>updateAllowed(6)} aria-label='delete' color='info' size='small'>
                    <Icon fontSize='inherit'>add</Icon>
                </IconButton>


            </DataTableBodyCell>
            <DataTableBodyCell  >
                {data.isFor} 
            </DataTableBodyCell>
            <DataTableBodyCell  >
                {data.step} <EditButton
                    onUpdateButtonClick={() => {
                        /* eslint no-underscore-dangle: 0 */
                        updateModal(columns[8], data.step??0)

                    }}
                />
            </DataTableBodyCell>

            <DataTableBodyCell  >
                <Switch checked={data.notifyCustomer} onChange={onChangeOfNotifyCustomer} />
            </DataTableBodyCell>
            <DataTableBodyCell>
                <DeleteButton
                    onDelete={() => {

                        onDelete(data._id);
                    }}
                /></DataTableBodyCell>

        </TableRow>
    )
}
RepairingStatusRow.propTypes = {
    data: PropTypes.objectOf.isRequired,
    currentParams: PropTypes.objectOf.isRequired,
    onDelete: PropTypes.func.isRequired,
    onUpdateButtonClick: PropTypes.func.isRequired,
    onBooleanChanges: PropTypes.func.isRequired,
    columns: PropTypes.arrayOf(PropTypes.any).isRequired
};
export default memo(RepairingStatusRow);
